module.exports = __webpack_public_path__ + "static/media/shaff1118.29410530.jpg";